import React, { FC, useMemo, useState } from "react";
import { MultiTabView } from "../../common/multitab/MultiTabView";
import { TabInfo } from "../../common/multitab/TabInfo";
import { RampartAuthorized } from "../../rampart/RampartAuthorized";
import { ShippingTimelineResyncTab } from "./ShippingTimelineResyncTab";

/**
 * Admin page for resyncing shipping timelines. Uses the shared multi-tab form
 * template (header + tabbed body + FooterActionBar) so it matches other create
 * forms in the app such as /stores/new. There is a single tab today; the
 * template supports more without changes.
 */
export const ShippingTimelinePage: FC = () => {
    const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

    const tabs: TabInfo[] = useMemo(
        () => [
            {
                label: "Resync",
                tabId: "resync",
                component: <ShippingTimelineResyncTab />,
            },
        ],
        [],
    );

    return (
        <RampartAuthorized requiredGroups={["juniper.self-serve.admin"]}>
            <MultiTabView
                header={"Shipping Timelines"}
                tabs={tabs}
                selectedTabIndex={selectedTabIndex}
                onTabSelected={setSelectedTabIndex}
            />
        </RampartAuthorized>
    );
};
